import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_ENDPOINT;

// global configs
axios.defaults.paramsSerializer = { indexes: null };

const api = axios.create({
  baseURL: API_BASE_URL,
});

export const authApi = axios.create({
  baseURL: `${API_BASE_URL}/auth`,
});

export const smartFormApi = axios.create({
  baseURL: `${API_BASE_URL}/fgt`,
});

export const imageEditorApi = axios.create({
  baseURL: `${API_BASE_URL}/image-editor`,
});

export const fileManagerApi = axios.create({
  baseURL: `${API_BASE_URL}/file-manager`,
});

export const cdrApi = axios.create({
  baseURL: `${API_BASE_URL}/cdr`,
});

export const homeApi = axios.create({
  baseURL: `${API_BASE_URL}/home`,
});

export const tenantBasicApi = axios.create({
  baseURL: `${API_BASE_URL}/tenant-basic`,
});

export const inisApi = axios.create({
  baseURL: `${API_BASE_URL}/inis`,
});

export const sdrsApi = axios.create({
  baseURL: `${API_BASE_URL}/sdrs`,
});

export const basicApi = axios.create({
  baseURL: `${API_BASE_URL}/basic`,
});

export const services = [
  api,
  authApi,
  smartFormApi,
  imageEditorApi,
  fileManagerApi,
  cdrApi,
  homeApi,
  tenantBasicApi,
  inisApi,
  sdrsApi,
  basicApi,
];
